/**
 * FloatingHelpButton — the "?" FAB. Opens the dedicated in-app Help Center
 * (logged-in users) or the public Support Center (visitors). No more modal —
 * per user request the help experience is a full page with its own back
 * navigation and an ask-a-question form.
 */
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { HelpCircle } from "lucide-react";

// Routes where the FAB overlaps critical UI or where a dedicated assistant lives — hide there
// Landing (/) shows AskFRBubble instead, so hide the "?" FAB there.
const NO_FAB_PATHS = [/^\/$/, /^\/privacy-onboarding/, /^\/add-member/, /^\/login/, /^\/signup/, /^\/admin/, /^\/help/];
// Routes with the mobile bottom tab bar (h-16) — lift the FAB above it on small screens
const TABBAR_PATHS = [/^\/dashboard/, /^\/family$/, /^\/person\//, /^\/coming-soon/];

export function FloatingHelpButton() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    if (NO_FAB_PATHS.some((re) => re.test(location.pathname))) return null;

    const aboveTabBar = TABBAR_PATHS.some((re) => re.test(location.pathname));

    return (
        <button
            type="button"
            data-testid="help-fab"
            aria-label="Get help"
            onClick={() => navigate("/help")}
            className={`fixed ${aboveTabBar ? "bottom-20" : "bottom-5"} right-4 sm:bottom-6 sm:right-6 z-[60] h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-[#1B5E20] hover:bg-[#154d1a] text-white shadow-[0_8px_30px_rgba(27,94,32,0.35)] flex items-center justify-center transition-all hover:-translate-y-0.5`}
        >
            <HelpCircle className="h-6 w-6" />
        </button>
    );
}
